import { first, last, sortBy, toLower, uniq, uniqBy, upperFirst } from "lodash";
import moment from "moment";

export const numberToCurrency = (
  number: number,
  showPrefix: boolean = true
): string => {
  const currency = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(number / 100);

  if (showPrefix) {
    return currency;
  } else {
    return currency.replace("R$", "").trim();
  }
};

export const formatDate = (date: string, format: string = "L"): string => {
  return date && moment(date).format(format);
};

export const formatNumber = (number: number): string => {
  return new Intl.NumberFormat("pt-BR").format(number);
};

export const formatCPF = (cpf: string): string => {
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};

export const uniqueValuesString = (list: [], key: string) =>
  uniqBy(list, (item) => toLower(item[key]))
    .map((item) => upperFirst(item[key]))
    .join(" / ");

export const rangeOfNumbers = (list: number[]) => {
  const sortedList = sortBy(list);

  return uniq([first(sortedList), last(sortedList)]).join(" a ");
};
